'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);

var useSortedArray = function (items, callback) { return (React.useMemo(function () { return tslib_es6.__spread(items).sort(callback); }, [items, callback])); };

exports.useSortedArray = useSortedArray;
